export default __webpack_public_path__ + "static/media/info-box.fcdaac37.png";